/* mk-card-tip: full-title tooltip for clamped product-card headings.
   Hover-capable devices only; shows only when the title is actually
   truncated. Generated by miakarts_card_align.py. */
(function () {
  if (window.__mkCardTip) return;
  window.__mkCardTip = true;
  if (!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
  var tip = null, onEl = null;
  function hide() {
    if (tip) tip.classList.remove('is-on');
    onEl = null;
  }
  function show(el) {
    if (el.scrollHeight <= el.clientHeight + 2) return; // not truncated
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'mk-card-tip';
      tip.setAttribute('role', 'tooltip');
      document.body.appendChild(tip);
    }
    tip.textContent = el.textContent.trim();
    var r = el.getBoundingClientRect();
    tip.style.left = '0px'; tip.style.top = '0px';
    tip.classList.add('is-on');
    var w = tip.offsetWidth, h = tip.offsetHeight;
    var left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8));
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 8) top = r.top - h - 8;
    tip.style.left = left + 'px';
    tip.style.top = Math.max(8, top) + 'px';
    onEl = el;
  }
  document.addEventListener('mouseover', function (e) {
    var el = e.target && e.target.closest && e.target.closest('.product-card__heading');
    if (el && el !== onEl) show(el);
    else if (!el && onEl) hide();
  }, { passive: true });
  document.addEventListener('scroll', hide, { passive: true, capture: true });
  document.addEventListener('click', hide, { passive: true });
})();
